<template>
  <div class="fluid" id="clausulList">
    <div>
      <div class="clausul-list-div">
        <v-card elevation="0" class="px-3 py-2" style="width: 100%">
          <v-row>
            <v-col
              cols="12"
              class="d-flex"
              style="
                position: relative;
                padding: 0 20px;
                text-align: center;
                margin-top: 20px;
              "
            >
              <h4 class="indigo--text" style="font-weight: bold; margin: auto">
                MASTER KLAUSUL
                <v-tooltip bottom color="grey">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      v-bind="attrs"
                      v-on="on"
                      x-small
                      text
                      icon
                      color="grey darken-2"
                      @click="getDataFromApi"
                    >
                      <v-icon small>mdi-refresh</v-icon>
                    </v-btn>
                  </template>
                  <span>refresh page</span>
                </v-tooltip>
              </h4>
            </v-col>
            <v-col cols="12">
              <v-toolbar
                class="group-list-toolbar-1"
                flat
                style="border-radius: 10px 10px 0 0; padding-top: 15px"
              >
                <div class="d-flex align-content-start">
                  <div
                    style="margin-right: 15px; height: 45px"
                    class="d-flex justify-center align-center"
                  >
                    <v-btn
                      style="font-size: 12px"
                      @click="addClause"
                      elevation="2"
                      tilerounded="5px"
                      color="primary"
                      class="white--text"
                      small
                    >
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon v-bind="attrs" v-on="on" small class="">
                            mdi-plus
                          </v-icon>
                        </template>
                        <span>Add Klausul</span>
                      </v-tooltip>
                    </v-btn>
                  </div>
                </div>
                <div style="width: 210px; height: 45px; margin-left: 10px">
                  <v-autocomplete
                    v-model="paramAPI.company_id"
                    label="Perusahaan"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    @change="companyWatcher"
                    :items="dropdown.company"
                    :disabled="isDisableCompanyDropdown"
                  ></v-autocomplete>
                </div>
                <div style="width: 180px; height: 45px; margin-left: 10px">
                  <v-autocomplete
                    v-model="paramAPI.area_id"
                    label="Area"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    @change="areaWatcher"
                    :items="dropdown.area"
                  ></v-autocomplete>
                </div>
                <div style="width: 180px; height: 45px; margin-left: 10px">
                  <v-autocomplete
                    v-model="paramAPI.scope_id"
                    label="Scope"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    @change="scopeWatcher"
                    :items="dropdown.scope"
                  ></v-autocomplete>
                </div>
              </v-toolbar>
              <v-toolbar
                class="group-list-toolbar-1"
                flat
                style="
                  height: 60px;
                  border-radius: 10px 10px 0 0;
                  padding-top: 15px;
                "
              >
                <div style="width: 180px; height: 45px">
                  <v-autocomplete
                    v-model="paramAPI.audit_type_id"
                    label="Audit Type"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    @change="auditTypeWatcher"
                    :items="dropdown.auditType"
                  ></v-autocomplete>
                </div>
                <div style="width: 180px; height: 45px; margin-left: 10px">
                  <v-autocomplete
                    v-model="paramAPI.clause_category_id"
                    label="Category"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    @change="categoryWatcher"
                    :items="dropdown.category"
                  ></v-autocomplete>
                </div>
                <div style="width: 310px; margin-left: auto; margin-top: 20px">
                  <v-text-field
                    v-model="paramAPI.keyword"
                    @keyup.enter="searchEnter"
                    label="Search here"
                    type="search"
                    append-icon="mdi-magnify"
                    outlined
                    dense
                  ></v-text-field>
                </div>
              </v-toolbar>
            </v-col>

            <v-col cols="12" style="width: 100%">
              <v-data-table
                v-if="result.length > 0 || !skeleton_loading"
                mobile-breakpoint="0"
                fixed-header
                height="50vh"
                :headers="headers"
                style="cursor: pointer"
                :items="result"
                :loading="loading"
                @click:row="rowClick"
                item-key="id"
                :options.sync="options"
                :footer-props="{
                  showFirstLastPage: true,
                  showCurrentPage: true,
                  itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                }"
                :server-items-length="totalData"
                :page="paramAPI.page"
                @update:page="updatePage"
                :items-per-page="paramAPI.itemsPerPage"
                @update:items-per-page="updateItemPerPage"
              >
                <template v-slot:[`item.no`]="{ index }">
                  <div
                    style="
                      font-size: 14px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ index + 1 + paramAPI.offset * paramAPI.limit }}
                  </div>
                </template>
                <template v-slot:[`item.description`]="{ item }">
                  <div
                    style="
                      width: 210px;
                      font-size: 14px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                      color: green;
                    "
                  >
                    {{ item.description }}
                  </div>
                </template>
                <template v-slot:[`item.clause_no`]="{ item }">
                  <div
                    style="
                      width: 120px;
                      font-size: 14px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ item.clause_no }}
                  </div>
                </template>
                <template v-slot:[`item.clause_category`]="{ item }">
                  <div
                    style="
                      width: 160px;
                      font-size: 14px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{
                      item.clause_category != null
                        ? item.clause_category.name
                        : ''
                    }}
                  </div>
                </template>
                <template v-slot:[`item.reference`]="{ item }">
                  <div
                    style="
                      width: 120px;
                      font-size: 14px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ item.reference }}
                  </div>
                </template>
                <template v-slot:[`item.company_ids`]="{ item }">
                  <!-- <div
                    style="
                      width: 120px;
                      font-size: 10px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ convertCompanyIds(item) }}
                  </div> -->
                  <div
                    style="
                      width: 210px;
                      font-size: 12px;
                      padding: 0;
                      overflow: auto;
                    "
                  >
                    <v-chip
                      v-for="(obj, idx) in item.company_ids"
                      :key="idx"
                      label
                      outlined
                      small
                      style="
                        position: relative;
                        margin-right: 5px;
                        padding: 0 3px;
                        cursor: pointer;
                        border: 1px solid rgba(0, 0, 0, 0.5);
                      "
                    >
                      {{ getCompanyAlias(obj) }}
                    </v-chip>
                  </div>
                </template>
                <template v-slot:[`item.location`]="{ item }">
                  <div v-if="item.audit_type_id != null">
                    <div
                      style="
                        width: 210px;
                        height: 50px;
                        font-size: 12px;
                        padding: 2px;
                        overflow: auto;
                      "
                    >
                      <div v-if="item.audit_type_id == 1">
                        <v-chip
                          v-for="(obj, idx) in item.scope_ids"
                          :key="idx"
                          label
                          outlined
                          small
                          style="
                            position: relative;
                            margin-right: 5px;
                            padding: 0 3px;
                            cursor: pointer;
                            border: 1px solid rgba(0, 0, 0, 0.5);
                          "
                        >
                          {{ getScopeName(obj) }}
                        </v-chip>
                      </div>
                      <div v-if="item.audit_type_id == 2">
                        <v-chip
                          v-for="(obj, idx) in item.area_ids"
                          :key="idx"
                          label
                          outlined
                          small
                          style="
                            position: relative;
                            margin-right: 5px;
                            padding: 0 3px;
                            cursor: pointer;
                            border: 1px solid rgba(0, 0, 0, 0.5);
                          "
                        >
                          {{ getAreaName(obj) }}
                        </v-chip>
                      </div>
                    </div>
                  </div>
                </template>

                <template v-slot:[`item.audit_type`]="{ item }">
                  <div
                    style="
                      width: 70px;
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ item.audit_type != null ? item.audit_type.name : '' }}
                  </div>
                </template>
                <template v-slot:[`item.createdAt`]="{ item }">
                  <div
                    style="
                      width: 80px;
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ convertDate(item.createdAt) }}
                  </div>
                </template>
                <template v-slot:[`item.updatedAt`]="{ item }">
                  <div
                    style="
                      width: 80px;
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;
                    "
                  >
                    {{ convertDate(item.updatedAt) }}
                  </div>
                </template>

                <template v-slot:[`item.score_multiplier`]="{ item }">
                  <div
                    :style="`
                      width: 50px;
                      font-size: 12px;
                      padding: 0;`"
                  >
                    {{ item.score_multiplier }}
                  </div>
                </template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }"
                      ><v-icon
                        v-bind="attrs"
                        v-on="on"
                        @click.stop="rowClick(item)"
                        small
                        color="primary"
                        class="mr-2"
                      >
                        mdi-pencil
                      </v-icon>
                    </template>
                    <span>Edit</span>
                  </v-tooltip>
                  <v-tooltip right>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon
                        v-bind="attrs"
                        v-on="on"
                        small
                        color="error"
                        @click.stop="deleteItem(item)"
                      >
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Delete</span>
                  </v-tooltip>
                </template>
              </v-data-table>
              <v-skeleton-loader
                v-else
                style="width: 100%"
                type="table-heading, table-tbody, table-tfoot"
              ></v-skeleton-loader>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </div>
    <v-dialog v-model="formDialog" persistent max-width="800px">
      <v-card v-if="form !== null">
        <v-card-title>
          <span class="text-h5">Add/Edit Klausul</span>
        </v-card-title>
        <v-form ref="entryForm2" @submit.prevent="saveForm">
          <v-card-text>
            <v-container>
              <v-row no-gutters>
                <v-col cols="12" md="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Tipe Audit
                  </p>
                  <v-autocomplete
                    v-model="form.audit_type_id"
                    :items="dropdown.auditType"
                    :rules="rules.typeRules"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="8" class="d-flex flex-column pl-5">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Kategori
                  </p>
                  <v-autocomplete
                    v-model="form.clause_category_id"
                    :items="dropdown.category"
                    :rules="rules.categoryRules"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Klausul
                  </p>
                  <v-textarea
                    v-model="form.description"
                    :rules="rules.descRules"
                    dense
                    outlined
                    auto-grow
                    rows="2"
                  />
                </v-col>
                <v-col cols="12" md="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    No Klausul
                  </p>
                  <v-text-field
                    v-model="form.clause_no"
                    dense
                    outlined
                    style="height: 60px"
                  />
                </v-col>
                <v-col cols="12" md="8" class="d-flex flex-column pl-5">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Referensi
                  </p>
                  <v-text-field
                    v-model="form.reference"
                    dense
                    outlined
                    style="height: 60px"
                  />
                </v-col>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Perusahaan
                  </p>
                  <v-autocomplete
                    v-model="form.company_ids"
                    :items="dropdown.company"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    small-chips
                    deletable-chips
                    multiple
                    cache-items
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Area
                  </p>
                  <v-autocomplete
                    v-model="form.area_ids"
                    :items="dropdown.area"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    small-chips
                    deletable-chips
                    multiple
                    cache-items
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Scope
                  </p>
                  <v-autocomplete
                    v-model="form.scope_ids"
                    :items="dropdown.scope"
                    item-text="name"
                    item-value="id"
                    return-id
                    dense
                    outlined
                    clearable
                    small-chips
                    deletable-chips
                    multiple
                    cache-items
                  ></v-autocomplete>
                </v-col>

                <v-col cols="4" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Score Multiplier
                  </p>
                  <v-text-field
                    v-model="form.score_multiplier"
                    dense
                    outlined
                    type="number"
                    min="0"
                    style="height: 60px"
                  />
                </v-col>
                <!-- <v-col cols="5" class="d-flex flex-row">
                  <p
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Score Double ?
                  </p>

                  <v-checkbox
                    v-model="form.is_score_double"
                    style="margin: 0 0 0 10px; height: 25px; padding: 0"
                  ></v-checkbox>
                </v-col> -->
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeformDialog">
              Close
            </v-btn>
            <v-btn color="blue darken-1" text type="submit"> Save </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapMutations /* ,  mapActions */ } from 'vuex'
import buildType from '../../../services/buildType'
export default {
  name: 'masterclause',
  data: () => ({
    editDialog: false,
    formDialog: false,
    dssApi: buildType.apiURL('dss'),
    eSanqua: buildType.apiURL('esanqua'),
    build: process.env.VUE_APP_BUILD_TYPE,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'date',
      sortType: 'desc',
      company_id: null,
      area_id: null,
      scope_id: null,
      clause_category_id: null,
      audit_type_id: null
      // department_id: null
    },
    totalData: 0,
    form: null,
    detail: null,
    isEdit: false,

    options: {},
    actionValue: 0,
    headers: [
      {
        text: 'No',
        value: 'no',
        align: 'left',
        sortable: false
      },
      {
        text: 'Kategori',
        value: 'clause_category',
        align: 'left',
        sortable: false
      },
      {
        text: 'Klausul',
        value: 'description',
        align: 'left',
        sortable: false
      },
      {
        text: 'No Klausul',
        value: 'clause_no',
        align: 'left',
        sortable: false
      },
      {
        text: 'Ref',
        value: 'reference',
        align: 'left',
        sortable: false
      },
      {
        text: 'Type',
        value: 'audit_type',
        align: 'left',
        sortable: false
      },
      {
        text: 'Company ID',
        value: 'company_ids',
        align: 'left',
        sortable: false
      },
      {
        text: 'Area/Scope ID',
        value: 'location',
        align: 'left',
        sortable: false
      },
      {
        text: 'Score Multiplier',
        value: 'score_multiplier',
        align: 'left',
        sortable: false
      },
      // {
      //   text: 'Scope ID',
      //   value: 'scope_ids',
      //   align: 'left',
      //   sortable: false
      // },
      // {
      //   text: 'Created at',
      //   value: 'createdAt',
      //   align: 'left',
      //   sortable: false
      // },
      // {
      //   text: 'updated at',
      //   value: 'updatedAt',
      //   align: 'left',
      //   sortable: false
      // },
      {
        text: 'Actions',
        value: 'action',
        align: 'left',
        sortable: false
      }
    ],
    result: [],
    loading: false,
    isDisableCompanyDropdown: false,
    rules: {
      nameRules: [],
      typeRules: [],
      categoryRules: []
    },
    dropdown: {
      company: [],
      auditType: [],
      area: [],
      scope: [],
      category: []
    },
    skeleton_loading: true
  }),

  async mounted() {
    this.paramAPI.company_id = Number(
      this.getUserProfile.employee.company.plant_id
    )
    this.paramAPI.department_id = this.getUserProfile.employee.department_id
    if (this.getClausePageQuery !== null) {
      this.paramAPI = this.getClausePageQuery
    }
    setTimeout(async () => {
      await this.getDataFromApi()
      await this.initDropdown()
    }, 200)
  },
  computed: {
    ...mapGetters(['getUserProfile', 'getClausePageQuery'])
  },
  watch: {},
  methods: {
    // ...mapActions(['dropdownPlant']),
    ...mapMutations(['setClausePageQuery']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    async initDropdown() {
      this.dropdownCompany()
      this.dropdownAuditType()
      this.dropdownArea()
      this.dropdownScope()
      this.dropdownCategory()
    },
    resetSomeParam() {
      this.paramAPI.limit = this.paramAPI.itemsPerPage
      this.paramAPI.offset = 0
      this.paramAPI.page = 1
    },
    searchEnter() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    companyWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    auditTypeWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    areaWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    scopeWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    categoryWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },

    async dropdownCompany() {
      const level = this.getUserProfile.level.find(
        ({ id }) => id === '1' || id === '39'
      )
      let xFlag = false
      if (level !== undefined) {
        if (level.user_user_level !== null) {
          if (
            level.user_user_level.allowed_company === null ||
            level.user_user_level.allowed_company.length === 0
          ) {
            xFlag = true
          } else {
            this.dropdown.company = level.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          xFlag = true
        }
      } else {
        xFlag = true
      }

      if (xFlag) {
        if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
          this.isDisableCompanyDropdown = true
        } else {
          this.isDisableCompanyDropdown = false
        }
        axios
          .get(`${this.eSanqua}master/universal/plant/dropdown`)
          .then((res) => {
            this.dropdown.company = res.data.data
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },

    async dropdownAuditType() {
      await axios
        .get(`${this.dssApi}master/universal/audittype/dropdown`)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.auditType = res.data.data)
          }
          return (this.dropdown.auditType = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.auditType = [])
        })
    },

    async dropdownArea() {
      await axios
        .get(`${this.dssApi}master/universal/area/dropdown`)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.area = res.data.data)
          }
          return (this.dropdown.area = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.area = [])
        })
    },

    async dropdownScope() {
      await axios
        .get(`${this.dssApi}master/universal/scope/dropdown`)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.scope = res.data.data)
          }
          return (this.dropdown.scope = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.scope = [])
        })
    },
    async getDataFromApi() {
      this.loading = true
      await this.initDataTable()
        .then((data) => {
          if (data.status_code === '00') {
            this.totalData = data.total_record
            return (this.result = data.data)
          }
          return (this.result = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.result = [])
        })
      this.skeleton_loading = false
      this.loading = false
    },

    async dropdownCategory() {
      await axios
        .get(`${this.dssApi}master/universal/clausecategory/dropdown`)
        .then((res) => {
          if (res.data.status_code === '00') {
            return (this.dropdown.category = res.data.data)
          }
          return (this.dropdown.category = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.category = [])
        })
    },

    async initDataTable() {
      let url = `${this.dssApi}master/universal/clause/list?keyword=${
        this.paramAPI.keyword
      }&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
        this.paramAPI.limit
      }&join_table=[{"name":"audittype","alias":"audit_type"},{"name":"clausecategory","alias":"clause_category"}]`
      const filter = []
      if (this.paramAPI.company_id !== null) {
        filter.push(`{"company_ids": ${this.paramAPI.company_id}}`)
      }
      if (this.paramAPI.area_id !== null) {
        filter.push(`{"area_ids": ${this.paramAPI.area_id}}`)
      }
      if (this.paramAPI.scope_id !== null) {
        filter.push(`{"scope_ids": ${this.paramAPI.scope_id}}`)
      }
      if (this.paramAPI.clause_category_id !== null) {
        filter.push(
          `{"clause_category_id": ${this.paramAPI.clause_category_id}}`
        )
      }
      if (this.paramAPI.audit_type_id !== null) {
        filter.push(`{"audit_type_id": ${this.paramAPI.audit_type_id}}`)
      }
      url = url + `&filter=[${filter}]`
      this.setClausePageQuery(this.paramAPI)
      return await new Promise((resolve) => {
        axios
          .get(url)
          .then((res) => {
            console.log(res)
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },
    enableEdit() {
      var oldForm = this.form
      this.isEdit = !this.isEdit
      if (!this.isEdit) {
        this.form = oldForm
        if (this.form.act === 'add') {
          this.closeDialog()
        }
      }
    },

    rowClick(pItem) {
      this.form = {
        act: 'update',
        id: pItem.id,
        description: pItem.description,
        reference: pItem.reference,
        clause_no: pItem.clause_no,
        clause_category_id: pItem.clause_category_id,
        audit_type_id: pItem.audit_type_id,
        area_ids: pItem.area_ids,
        scope_ids: pItem.scope_ids,
        company_ids: pItem.company_ids,
        score_multiplier: pItem.score_multiplier
      }
      console.log(this.form)

      setTimeout(() => {
        this.formDialog = !this.formDialog
      }, 300)
    },
    async deleteItem(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          await axios
            .delete(`${this.dssApi}master/universal/clause/delete/${pItem.id}`)
            .then(async (res) => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                // this.resetSomeParam()
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
            })
            .catch((err) => {
              console.log(err)
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    closeDialog() {
      this.form = null
      this.isEdit = false
      setTimeout(() => {
        this.editDialog = false
      }, 300)
    },
    addClause() {
      this.form = {
        act: 'add',
        description: null,
        reference: null,
        clause_no: null,
        clause_category_id: null,
        audit_type_id: null,
        area_ids: null,
        scope_ids: null,
        company_ids: null,
        score_multiplier: null
      }
      setTimeout(() => {
        this.formDialog = !this.formDialog
      }, 300)
    },
    saveForm() {
      this.rules.descRules = [(v) => !!v || 'Klausul is required']
      this.rules.typeRules = [(v) => !!v || 'Type is required']
      this.rules.categoryRules = [(v) => !!v || 'Category Time is required']
      const self = this
      setTimeout(function () {
        if (self.$refs.entryForm2.validate()) {
          const form = {
            act: self.form.act,
            description: self.form.description,
            reference: self.form.reference,
            clause_no: self.form.clause_no,
            clause_category_id: self.form.clause_category_id,
            audit_type_id: self.form.audit_type_id,
            area_ids: self.form.area_ids,
            scope_ids: self.form.scope_ids,
            company_ids: self.form.company_ids,
            score_multiplier: self.form.score_multiplier || null
          }
          if (form.act === 'update') {
            Object.assign(form, { id: self.form.id })
          }
          self.submitForm(form)
        }
      })
    },
    async submitForm(form) {
      console.log(form)
      await axios
        .post(`${this.dssApi}master/universal/clause/save`, form)
        .then(async (res) => {
          console.log(res.data)
          if (res.data.status_code !== '-99') {
            this.showMsgDialog('success', res.data.status_msg, false)
            // this.resetSomeParam()
            this.getDataFromApi()
            this.closeformDialog()
          } else {
            if (res.data.status_msg === 'Parameter value has problem') {
              this.showMsgDialog(
                'warning',
                'Invalid input, Parameter value has problem',
                false
              )
            } else {
              this.showMsgDialog('warning', res.data.status_msg, false)
            }
          }
        })
        .catch((err) => {
          console.log(err)
          this.showMsgDialog(
            'error',
            err
              ? 'Something went wrong, Please contact an admin!'
              : 'Something went wrong, Please contact an admin!',
            false
          )
        })
    },
    closeformDialog() {
      this.formDialog = false
      setTimeout(() => {
        this.form = null
      }, 300)
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    },
    convertCompanyIds(xItem) {
      const result = xItem.company_ids.map((id) => {
        const company = this.dropdown.company.find((d) => d.id == id)
        if (!company) return null

        // Remove "PT" prefix
        const nameWithoutPT = company.name.replace(/^PT\s+/i, '')

        // Create initials
        const initials = nameWithoutPT
          .split(' ')
          .map((word) => word[0])
          .join('')
          .toUpperCase()

        return initials
      })

      return result
    },
    getCompanyAlias(obj) {
      // const xFindCompany = this.dropdown.company.find((d) => d.id == obj);
      // let initials = '-';
      // if (xFindCompany != undefined) {
      //   // Remove "PT" prefix
      //   const nameWithoutPT = xFindCompany.name.replace(/^PT\s+/i, '');

      //   // Create initials
      //   initials = nameWithoutPT
      //     .split(' ')
      //     .map((word) => word[0])
      //     .join('')
      //     .toUpperCase();
      // }
      // return initials;
      switch (obj) {
        case 1:
          return 'TMP'
        case 2:
          return 'IMP'
        case 3:
          return 'GIT'
        case 4:
          return 'KAJ'
        case 5:
          return 'WIM'
        case 6:
          return 'SMI'
        case 7:
          return 'THP'
        case 8:
          return 'GAI'
        case 9:
          return 'GPP'
        case 10:
          return 'BWN'
        case 11:
          return 'INO'
        case 12:
          return 'BPS'
        case 13:
          return 'BPC'
        case 14:
          return 'WIMS'
        case 15:
          return 'BWI'
        case 16:
          return 'DAM'
        case 17:
          return 'PSR'
        case 18:
          return 'GAP'
        case 19:
          return 'SKH'
        case 20:
          return 'PTI'
        case 21:
          return 'BMS'
        case 22:
          return 'SDA'
      }
    },
    getAreaName(obj) {
      const xFindArea = this.dropdown.area.find((d) => d.id == obj)
      let xAreaName = '-'
      if (xFindArea != undefined) {
        xAreaName = xFindArea.name
      }

      return xAreaName
    },
    getScopeName(obj) {
      const xFindScope = this.dropdown.scope.find((d) => d.id == obj)
      let xScopeName = '-'
      if (xFindScope != undefined) {
        xScopeName = xFindScope.name
      }

      return xScopeName
    }
  }
}
</script>
<style lang="scss">
#clausulList {
  position: relative;
  .clausul-list-div {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .group-list-toolbar-1 {
      .group-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .clausul-list-toolbar2 {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  #clausulList {
    .clausul-list-div {
      .group-list-toolbar-1 {
        .group-list-toolbar-1 {
          display: none;
        }
      }
      .clausul-list-toolbar2 {
        display: block;
      }
    }
  }
}
</style>
